import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { formatCurrency } from '../../utils/roles';

const DashboardPage = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard').then(res => setStats(res.data.data));
  }, []);

  const cards = [
    { label: 'Pedidos Hoy', value: stats?.today_orders ?? 0, icon: '📋', color: '#38bdf8' },
    { label: 'Ventas Hoy', value: formatCurrency(stats?.today_sales ?? 0), icon: '💰', color: '#10b981' },
    { label: 'Pedidos Activos', value: stats?.active_orders ?? 0, icon: '🔥', color: '#f59e0b' },
    { label: 'Items Pendientes', value: stats?.pending_items ?? 0, icon: '⏳', color: '#ef4444' },
    { label: 'Mesas Libres', value: stats?.free_tables ?? 0, icon: '🪑', color: '#8b5cf6' },
    { label: 'Mesas Ocupadas', value: stats?.occupied_tables ?? 0, icon: '🍽️', color: '#f472b6' },
  ];

  return (
    <div>
      <h1 style={{ color: '#e2e8f0', marginBottom: 24, fontSize: 28 }}>📊 Dashboard</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 }}>
        {cards.map((card, i) => (
          <div key={i} className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>{card.icon}</div>
            <p style={{ color: card.color, fontSize: 28, fontWeight: 700, marginBottom: 4 }}>{card.value}</p>
            <p style={{ color: '#94a3b8', fontSize: 13 }}>{card.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardPage;
